<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <div :style="{marginBottom:'10px'}">
      <demo-video-alert name="MianDan"></demo-video-alert>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId" />
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                  <a-select-option value="1">每人限购</a-select-option>
                  <a-select-option value="2">免单总数</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索关键字">
                <a-input v-model="queryParam.keywords" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" @click="$refs.activityAddModal.show(currentRobotId)">新增免单活动</a-button>
      </div>
      <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="goodsinfo" slot-scope="text, record">
          <a @click="handleShowGoodsinfo(record.item_info)">查看商品</a>
        </span>
        <span slot="user_group" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <span v-if="record.user_group">{{record.user_group | groupshow}}</span>
              <span v-else>无</span>
            </template>
            <a>参与会员分组</a>
          </a-tooltip>
        </span>
        <span
          slot="total_free"
          slot-scope="text, record"
        >{{record.total_free}} / {{record.schedule_person}}</span>
        <span slot="peer_limit" slot-scope="text">{{text}}</span>
        <span slot="rebate_type" slot-scope="text">{{text=='1'?'付款金额':'自定义金额'}}</span>
        <span slot="rebate_percent" slot-scope="text, record">
          <span v-if="record.rebate_type=='1'">{{text}}%</span>
          <span v-else>无</span>
        </span>
        <span slot="rebate_cash" slot-scope="text, record">
          <span v-if="record.rebate_type=='2'">{{text}}元</span>
          <span v-else>无</span>
        </span>
        <span slot="use_sub_union" slot-scope="text">{{text=='0'?'不使用':'使用'}}</span>
        <span
          slot="time_frame"
          slot-scope="text,record"
        >{{record.start_time.substring(0,16)}} 至 {{record.end_time.substring(0,16)}}</span>
        <span slot="action" slot-scope="text,record">
          <a-popconfirm placement="top" @confirm="handleDelete(record.id)">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <template slot="title">
              <p>确定要删除？</p>
            </template>
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
    </a-card>
    <activity-add-modal ref="activityAddModal" @ok="$refs.table.refresh()"></activity-add-modal>
    <goodsinfo-modal ref="goodsinfoModal"></goodsinfo-modal>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import ActivityApi from '@/api/activity'
import { PageView } from '@/layouts'
import { mapActions, mapGetters } from 'vuex'
import { ExceptionPage } from '@/components'
import ActivityAddModal from './modules/ActivityAddModal'
import GoodsinfoModal from './modules/GoodsinfoModal'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
export default {
  name: 'ActivityActivitylist',
  components: {
    PageView,
    STable,
    SearchRobot,
    ExceptionPage,
    ActivityAddModal,
    GoodsinfoModal,
    DemoVideoAlert
  },
  data() {
    return {
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          width: 10,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '商品信息',
          scopedSlots: { customRender: 'goodsinfo' }
        },
        {
          title: '总数 / 已领取',
          scopedSlots: { customRender: 'total_free' },
          width: 200
        },
        {
          title: '每人限购',
          scopedSlots: { customRender: 'peer_limit' },
          dataIndex: 'peer_limit'
        },
        {
          title: '参与分组',
          scopedSlots: { customRender: 'user_group' }
        },
        {
          title: '时间范围',
          scopedSlots: { customRender: 'time_frame' }
        },
        {
          title: '返利类型',
          scopedSlots: { customRender: 'rebate_type' },
          dataIndex: 'rebate_type'
        },
        {
          title: '返利比例',
          scopedSlots: { customRender: 'rebate_percent' },
          dataIndex: 'rebate_percent'
        },
        {
          title: '返利金额',
          scopedSlots: { customRender: 'rebate_cash' },
          dataIndex: 'rebate_cash'
        },
        {
          title: '是否使用副联盟',
          dataIndex: 'use_sub_union',
          scopedSlots: { customRender: 'use_sub_union' }
        },
        {
          title: '操作',
          width: '80px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return ActivityApi.getActivityList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId
          })
        )
      }
    }
  },
  filters: {
    goodsPlatform(str) {
      if (str == 1) {
        return '淘宝'
      } else if (str == 2) {
        return '京东'
      } else if (str == 3) {
        return '拼多多'
      }
    },
    groupshow(str) {
      const obj = JSON.parse(str)
      let text = ''
      obj.forEach((val, index) => {
        if (index > 0) {
          text += '，'
        }
        text += val.name
      })
      return text
    }
  },
  computed: {},
  created() {},
  methods: {
    ...mapActions(['demoSetVideo']),
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleShowGoodsinfo(goodsinfo) {
      const arr = JSON.parse(goodsinfo)
      this.$refs.goodsinfoModal.show(arr)
    },
    handleDelete(id) {
      let loading = this.$message.loading('正在删除')
      ActivityApi.removeActivity(this.currentRobotId, [id])
        .then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
